import * as React from 'react';

export function ParseStringToHTML(input?: string, className?: string, linkClassName?: string): any {

	if (input === undefined) {
		return undefined;
	}

	let outputList: any[] = [];

	let firstIndex = 0;
	let lastIndex = input.length;

	while (firstIndex !== -1 && lastIndex !== -1) {
		lastIndex = input.indexOf("<", firstIndex);
		if (lastIndex === -1) {
			outputList.push(input.substring(firstIndex, input.length))
		} else if (input.startsWith("<br/>", lastIndex)) {
			if (lastIndex - firstIndex > 0) {
				outputList.push(input.substring(firstIndex, lastIndex));
			}
			firstIndex = lastIndex + "<br/>".length;
			outputList.push(<React.Fragment key={firstIndex}> <br/> </React.Fragment>);
		} else if (input.startsWith("<a", lastIndex)) {
			let linkIndex = input.indexOf("href=", lastIndex);
			linkIndex = input.indexOf("'", linkIndex);

			let linkEndIndex = input.indexOf("'", linkIndex + 1);

			let link = input.substring(linkIndex + 1, linkEndIndex);

			let closeIndex = input.indexOf(">", lastIndex);
			let closeElementIndex = input.indexOf("</", closeIndex);
			let closeElementEndIndex = input.indexOf(">", closeElementIndex);

			let content = input.substring(closeIndex + 1, closeElementIndex);

			if (lastIndex - firstIndex > 0) {
				outputList.push(input.substring(firstIndex, lastIndex));
			}
			if (link !== "" && content !== "") {
				outputList.push(<a key={`${linkIndex}`} className={linkClassName} target='_blank' rel='noopener noreferrer' href={link}><b>{content}</b></a>);
			}

			firstIndex = closeElementEndIndex + 1;
		} else {
			outputList.push(input.substring(firstIndex, lastIndex - 1));
			firstIndex = lastIndex + 1;
		}


	}
	if (outputList.length > 0)
		return (
			<p className={className}>{outputList.map((value) => value)}</p>
		)

	return undefined;
}